import { gql } from '@apollo/client';

const GET_ALL_AVAILABLE_QUIZ = gql`
  query AllQuizz {
    availableQuiz(all: true) {
      id
      name
      debut
      fin
    }
  }
`;

export default GET_ALL_AVAILABLE_QUIZ;
